import { useTranslation } from 'react-i18next';
import PageHeader from '@/components/page-header';
import { setWebTitle } from '@/lib/format-utils';
import { useMoneyTransactionsIn } from '@/hooks/api-hooks';
import { SkeletonList } from '@/components/snippets';
import BalanceSummary from '@/components/balance-summary';
import MoneyTransactionsTable from '@/components/money-transactions-table';

export default function MoneyTransactionsInPage(): JSX.Element {
    const { t } = useTranslation();
    setWebTitle(t('money_in'));

    const {
        data,
        isLoading
    } = useMoneyTransactionsIn({});

    return (
        <div>
            <PageHeader
                title={t('money_in')}
            />
            <div className="panel-content">
                <BalanceSummary moneyTransactions={data?.data || []} />

                <MoneyTransactionsTable
                    moneyTransactions={data?.data || []}
                />

                {isLoading && <SkeletonList />}
            </div>
        </div>
    );
}
